export default __webpack_public_path__ + "static/media/add_credit.5f186a4d.svg";